<template>
	<div>
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item"><router-link to="/users">Felhasználók</router-link></li>
			<li class="breadcrumb-item active">{{user.name}}</li>
		</ol>
		<h1 class="page-header"><i class="fa fa-user-pen"></i> Felhasználó szerkesztése</h1>
		<Loading v-if="user === false" title="Felhasználó betöltése"></Loading>
		<NoRecords v-else-if="user.notfound" main_icon="fas fa-user-lock" value="false" title="Nem található a felhasználó" subtitle="Menjen vissza a felhasználókhoz!"></NoRecords>
		<div class="row" v-else>
			<div class="col-md-6">
				<panel title="Alapadatok">
					<form @submit.prevent="updateUser">
						<div>
							<div class="form-group">
								<label class="form-label">Név:</label>
								<input class="form-control" type="text" v-model="user.name" required :class="{'is-invalid' : errors.name}">
								<div class="invalid-feedback d-block" v-if="errors.name">
										{{ errors.name[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Email:</label>
								<input class="form-control" type="email" v-model="user.email" required :class="{'is-invalid' : errors.email}">
								<div class="invalid-feedback d-block" v-if="errors.email">
										{{ errors.email[0] }}
								</div>
							</div>
						</div>
						<div class="text-end mt-2">
							<button type="submit" class="btn btn-success btn-icon btn-lg"><i class="fa fa-save"></i></button>
						</div>
					</form>
				</panel>
			</div>
			<div class="col-md-6">
				<panel title="Részletek">
					<form @submit.prevent="updateDetails">
						<div>
							<div class="form-group">
								<label class="form-label">Tagazonosító:</label>
								<input class="form-control" type="text" v-model="user.details.membership_id" :class="{'is-invalid' : errors.membership_id}">
								<div class="invalid-feedback d-block" v-if="errors.membership_id">
										{{ errors.membership_id[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Irányítószám:</label>
								<input class="form-control" type="text" v-model="user.details.postal_code" :class="{'is-invalid' : errors.postal_code}">
								<div class="invalid-feedback d-block" v-if="errors.postal_code">
										{{ errors.postal_code[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Város:</label>
								<input class="form-control" type="text" v-model="user.details.city" :class="{'is-invalid' : errors.city}">
								<div class="invalid-feedback d-block" v-if="errors.city">
										{{ errors.city[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Cím:</label>
								<input class="form-control" type="text" v-model="user.details.street_address" :class="{'is-invalid' : errors.street_address}">
								<div class="invalid-feedback d-block" v-if="errors.street_address">
										{{ errors.street_address[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Telefonszám:</label>
								<input class="form-control" type="text" v-model="user.details.phone" :class="{'is-invalid' : errors.phone}">
								<div class="invalid-feedback d-block" v-if="errors.phone">
										{{ errors.phone[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Születési dátum:</label>
								<input class="form-control" type="text" v-model="user.details.birth_date" :class="{'is-invalid' : errors.birth_date}">
								<div class="invalid-feedback d-block" v-if="errors.birth_date">
										{{ errors.birth_date[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Adóazonosító:</label>
								<input class="form-control" type="text" v-model="user.details.tin" :class="{'is-invalid' : errors.tin}">
								<div class="invalid-feedback d-block" v-if="errors.tin">
										{{ errors.tin[0] }}
								</div>
							</div>
						</div>
						<div class="text-end mt-2">
							<button type="submit" class="btn btn-success btn-icon btn-lg"><i class="fa fa-save"></i></button>
						</div>
					</form>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
	import User from "../../apis/User";

	export default {
		data() {
			return {
				user:false,
				loading: false,
				roles: false,
				errors: [],
			}
		},
		created() {
			this.roles = JSON.parse(localStorage.getItem('constants')).roles;
			User.show(this.$route.params.id)
			.then(response => {
				this.user = response.data;
			});
		},
		methods: {
			updateUser(){
				User.updateAdmin(this.user.id,this.user)
				.then(() => {
					this.errors = [];
				})
				.catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				});
			},
			updateDetails(){
				User.updateDetails(this.user.details.id,this.user.details)
				.then(() => {
					this.errors = [];
				})
				.catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				});
			},
		},
	}
</script>

<style>
	
</style>